module.exports = __webpack_public_path__ + "static/img/org_title6.ffa438f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cec2022/org_title6.png
// module id = 1ivM
// module chunks = 4